// TH
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    TITLE: "เมนู",
    DASHBOARD: {
      TITLE: "แดชบอร์ด"
    },
    USER_MANAGEMENT: {
      TITLE: "จัดการผู้ใช้งาน",
      NEWSLETTER: "ส่งข่าวสาร",
      ADMIN: "ผู้ดูแล",
      USER: "ผู้ใช้งาน",
    },
    MANGROVE_INFO: {
      TITLE: "จัดการตำแหน่งไม้โกงกาง",

      NAME: "ตำแหน่งไม้โกงกาง",
    },
    PROFILE: {
      TITLE: "ข้อมูลส่วนตัว"
    },
    LOGOUT: {
      TITLE: "ออกจากระบบ"
    }
  },
  AUTH: {
    TITLE: "C-Aoss Admin System",
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "เข้าสู่ระบบ",
      BUTTON: "ตกลง",
      FORM_INVALID: "กรุณาระบุข้อมูลให้ถูกต้อง"
    },
    FORGOT: {
      TITLE: "ลืมรหัสผ่าน",
      DESC: "ระบุอีเมล์เพื่อเปลี่ยนรหัสผ่าน",
      SUCCESS: "Your account has been successfully reset.",
      FORM_INVALID: "กรุณาระบุข้อมูลให้ถูกต้อง"
    },
    UPDATE_PASSWORD: {
      TITLE: "เปลี่ยนรหัสผ่าน",
      DESC: "ระบบได้ส่งรหัสที่ใช้ในการเปลี่ยนรหัสผ่านไปยังอีเมล์ของคุณแล้ว",
      TIME_ALEAT: "กรุณาเปลี่ยนรหัสผ่านภายใน {second} วินาที",
      TIMEOUT: "รหัสหมดอายุ"
    },
    REGISTER: {
      TITLE: "สมัครสมาชิก",
      DESC: "กรอกรายละเอียดบัญชีของคุณ",
      SUCCESS: "บัญชีของคุณถูกสร้างเรียบร้อยแล้ว.",
      NEW_USER: "สมาชิกใหม่?",
      CREATE_ACCOUNT: "สมัครสมาชิกที่นี่"
    },
    INPUT: {
      EMAIL: "อีเมล์",
      FULLNAME: "ชื่อ-สกุล",
      PASSWORD: "รหัสผ่าน",
      CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
      USERNAME: "ชื่อผู้ใช้งาน",
      CODE: "รหัส",
      NEW_PASSWORD: "รหัสผ่านใหม่",
      CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่",
      SUBMIT: "ตกลง",
      CANCEL: "ยกเลิก"
    },
    VALIDATION: {
      INVALID: "ข้อมูลไม่ถูกต้อง",
      REQUIRED: "กรุณาระบุข้อมูล",
      MIN_LENGTH: "กรุณาระบุอย่างน้อย {min} อักษร",
      MAX_LENGTH: "กรุณาระบุไม่เกิน {max} อักษร",
      MIN_MAX_LENGTH: "กรุณาระบุย่างน้อย {min} อักษร และไม่เกิน {max} อักษร",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "ข้อมูลไม่ถูกต้อง",
      CUSTOM_REQUIRED: "กรุณาระบุ {field}"
    }
  },
  PAGE: {
    DEFAULT: {
      TABLE: {
        SEARCH: "ค้นหา",
        CLEAR: "ลบ",
        NEW: "เพิ่ม",
        DATA_NOT_FOUND: "ไม่พบข้อมูล",
        FIELDS: {
          INDEX: "ลำดับ",
          NAME: "ชื่อ",
          SWITCH: "การใช้งาน",
          STATUS:"สถานะ",
          ACTION: {
            TITLE: "จัดการ",
            EDIT: "แก้ไข",
            PREVIEW: "ดูตัวอย่าง",
            DELETE: {
              TITLE: "ลบ",
              DESC: "ยืนยันการลบข้อมูล",
              CONFIRM:"คุณต้องการจะลบใช่หรือไม่"
            }
          },
        },
        PER_PAGE: "จำนวนข้อมูล"
      },
      FORM: {
        TITLE: "ฟอร์ม",
        FIELDS: {
          NAME: "ชื่อ",
          COMPANY: "บริษัท"
        },
        BTN_SUBMIT: "ตกลง",
        TESTVIDEO:"Test Stream",
        BTN_SAVE: "บันทึก",
        BTN_OK: "ตกลง",
        BTN_CANCEL: "ยกเลิก",
        BTN_PREVIEW: "Preview",
        VALIDATION: {
          UPLOAD: "กรุณาเลือกไฟล์และupload",
          INVALID: "ข้อมูลไม่ถูกต้อง",
          REQUIRED: "กรุณาระบุข้อมูล",
          REQUIRED_ALL: "กรุณาระบุข้อมูลให้ครบ",
          MIN_LENGTH: "กรุณาระบุอย่างน้อย {min} อักษร",
          MAX_LENGTH: "กรุณาระบุไม่เกิน {max} อักษร",
          MIN_MAX_LENGTH:
            "กรุณาระบุย่างน้อย {min} อักษร และไม่เกิน {max} อักษร",
          LINK: "กรุณาระบุ Link",
          INTEGER: "กรุณาระบุข้อมูลเป็นตัวเลข",
          MIN_VALUE: "กรุณาระบุข้อมูลเป็นตัวเลขมากกว่า {min}",
          AT_LEAST_ONE: "กรุณาระบุข้อมูลอย่างใดอย่างนึง",
          SPECIAL_CHAR:
            "ไม่สามารถกรอกตัวอักษรพิเศษได้ (`!@#$%^&*+=[]{};':\"\\|,<>/?~)"
        },
      }
    },
    USER: {
      TABLE: {
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์",
          TYPE:"ประเภทผู้ใช้",
          TIME:"วันที่สมัคร",
        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          TYPE:"ประเภทผู้ใช้",
          EMAIL: "อีเมล์",
          SANSOR:"SansorName",
          VIDEOURL:"Video Url",
          NAMEVIDEO:"ชื่อ",
          IP:"API URL:",
          MOVE:"ข้อมูลเพิ่มเติม",
          ID_CARD: "เลขบัตรประชาชน",
          PHONE_NUMBER: "หมายเลขโทรศัพท์",
          ADDRESS: "ที่อยู่",
          USER_TYPE: "ประเภทผู้ใช้งาน",
          COMPANY: "บริษัท",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่",
          IS_SUBSCRIBED: "แจ้งเตือนข่าวสาร",
          USER_GROUP: "กลุ่มผู้ใช้งาน"
        }
      }
    },
    MANGROVE: {
      TABLE: {
        FIELDS: {
          NAME: "ชื่อ",
          NAMESENSOR: "ชื่อเซ็นเซอร์",
          IP: "API URL",
          MORE:"เพิ่มเติม"

        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          NAME: "ชื่อ",
          NAMESENSOR: "ชื่อเซ็นเซอร์",
          IP: "IP",
          DETAIL:"ข้อมูลเพิ่มเติม",
          LATITUDE:"latitude",
          LONGTITUDE:"longitude",
          DATA:"ข้อมูล",
          LOCATION:"ตำแหน่ง",
          EMAIL: "อีเมล์",
          ID_CARD: "เลขบัตรประชาชน",
          PHONE_NUMBER: "หมายเลขโทรศัพท์",
          ADDRESS: "ที่อยู่",
          USER_TYPE: "ประเภทผู้ใช้งาน",
          COMPANY: "บริษัท",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่",
          IS_SUBSCRIBED: "แจ้งเตือนข่าวสาร",
          USER_GROUP: "กลุ่มผู้ใช้งาน"
        }
      }
    },
    PIN_INFOMATION: {
      FORM: {
        FIELDS: {
          NAME:"ข้อมูลการปัก",
          NUMBER: "จำนวนที่ปัก",
          DISPLAY_NAME: "Display name",
          URL: "Url",
          PATTERN:"รูปแบบการติดตั้ง",
          LATITUDE:"latitude",
          LONGTITUDE:"longitude",
          DATA:"ข้อมูล",
          LOCATION:"ตำแหน่ง",
        }
      }
    },
    MORE_DERAIL_INFO: {
      FORM: {
        FIELDS: {
          NAME:"ข้อมูลเพิ่มเติม",
          NUMBER: "จำนวนที่ปัก",
          DISPLAY_NAME: "Display name",
          URL: "Url",
          PATTERN:"รูปแบบการติดตั้ง",
          LATITUDE:"latitude",
          LONGTITUDE:"longitude",
          DATA:"ข้อมูล",
          LOCATION:"ตำแหน่ง",
        }
      }
    },
    POINTS_COULD: {
      FORM: {
        FIELDS: {
          NAME:"3D Points Could",
          TYPE:"ประเภท",
          NAME_FORM:"เพิ่มข้อมูล 3D Points Could",
          DATE:"วันที่",
          DOC_FILE:"อัพโหลดไฟล์",
          DETAIL:"รายละเอียด",
          ACTION:"จัดการ"
        }
      }
    },
    GALLERY: {
      FORM: {
        FIELDS: {
          NAME:"รูปภาพจากคนในพื้นที่",
          TYPE:"ประเภท",
          NAME_FORM:"เพิ่มข้อมูล 3D Points Could",
          DATE:"วันที่",
          DOC_FILE:"อัพโหลดไฟล์"
        }
      }
    },
    PROFILE: {
      TABLE: {
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์"
        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่"
        }
      }
    }
  },


  RESPONSE_MESSAGE: {
    USER_NOT_FOUND: "ไม่พบผู้ใช้งาน",
    EMAIL_DUPICATE: "อีเมล์นี้มีผู้ใช้งานแล้ว",
    CODE_EXPIRED: "รหัสหมดอายุการใช้งาน",
    SUCCESS_TO_SAVE_DATA: "บันทึกข้อมูลสำเร็จ",
    FAIL_TO_SAVE_DATA: "บันทึกข้อมูลไม่สำเร็จ",
    SUCCESS_TO_DELETE_DATA: "ลบข้อมูลสำเร็จ",
    FAIL_TO_DELETE_DATA: "ลบข้อมูลไม่สำเร็จ",
    DATA_INVALID: "ข้อมูลไม่ถูกต้อง",
    DATA_NOT_FOUND: "ไม่พบข้อมูล",
    ERROR_OCCURRED: "บันทึกข้อมูลไม่สำเร็จ",
    DATA_DUPICATE: "มีข้อมูลนี้แล้ว",
    DATA_USED: "ข้อมูลนี้กำลังใช้งานอยู่",
    DATE_DUPICATE: "มีข้อมูลวันที่นี้แล้ว",
    SUCCESS_TO_SAVE_NEW_PASSWORD: "เปลี่ยนรหัสผ่านสำเร็จ",
    SYSTEM_ERROR: "ระบบเกิดข้อผิดพลาด",
    SENT_EMAIL_ERROR: "ระบบส่งอีเมลล์ผิดพลาด",
    SENT_EMAIL_NOT_FOUND : "ไม่พบผู้ใช้งานที่ต้องการส่งถึง",
    LOADING_SENT_EMAIL : "กำลังส่งอีเมลล์"
  },
  LOADING: "กำลังโหลด"
};
